import { Link } from "react-router-dom";
import type { MediaItem } from "@/utils/media";
import { TYPE_LABEL } from "@/utils/media";

interface MediaCardProps {
  item: MediaItem;
  showDesc?: boolean;
}

export default function MediaCard({ item, showDesc = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 爱情${TYPE_LABEL[item.type]}海报`}
          title={`${item.title} 爱情影视资源`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 text-xs rounded-md bg-background-50/90 text-primary-700 font-medium">
          {TYPE_LABEL[item.type]}
        </span>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs rounded-md bg-foreground-950/70 text-background-50 font-medium flex items-center gap-1">
          <i className="ri-star-fill text-accent-400"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="w-1 h-1 rounded-full bg-background-300"></span>
          <span>{item.region}</span>
        </div>
        {showDesc && (
          <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">
            {item.shortDesc}
          </p>
        )}
      </div>
    </Link>
  );
}